const AUTH_SERVICE_URL: string = import.meta.env.VITE_API_BASE_URL.replace(
  '/uat',
  '',
);

const identityBase = `${AUTH_SERVICE_URL}identity/auth/`;

export const IdentityEndpoints = {
  login: `${identityBase}login`,
  ssoVerify: `${identityBase}sso/verify`,
  getTokensFromSSO: `${identityBase}sso/exchange/token`,
  exchangeRefreshToken: `${identityBase}token`,
  upgradeLegacyToken: `${identityBase}token/upgrade`,
  logout: `${identityBase}logout`,
  passwordForgotRequest: `${identityBase}password/forgot/request`,
  passwordForgotReset: `${identityBase}password/forgot/reset`,
} as const;

export const isTokenExchangeRequest = (url?: string): boolean =>
  !!url && url.includes(IdentityEndpoints.exchangeRefreshToken);

const AUTH_CHALLENGE_ENDPOINTS: string[] = [
  IdentityEndpoints.login,
  IdentityEndpoints.ssoVerify,
  IdentityEndpoints.getTokensFromSSO,
  IdentityEndpoints.exchangeRefreshToken,
  IdentityEndpoints.upgradeLegacyToken,
];

export const isAuthChallengeRequest = (url?: string): boolean =>
  !!url && AUTH_CHALLENGE_ENDPOINTS.some((endpoint) => url.includes(endpoint));
